import React from "react";
import "./../../App.css";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

import DialogTitle from "@mui/material/DialogTitle";

import * as dateFns from "date-fns";
import QRCODE from "qrcode.react";

export interface SimpleDialogProps {
  setViewDialog: Function;
}

function SimpleDialog(props: SimpleDialogProps) {
  const { setViewDialog } = props;

  const person = {
    Name: "Mukamurangwa Mupac",
    Contact: 25775623422,
    Rooms: [
      {
        description: "Parent's room VIP",
      },
      { description: "Children's room" },
    ],
    Npeople: 4,
    Arrivaldate: 1666888497462,
    Hotel: "Selena Hotel",
    Days: "three",
  };

  return (
    <div
      className={`w-screen lg:h-screen max-h-fit py-5 md:h-full bg-black/10 z-[2] absolute top-0 left-0 flex items-center justify-center`}
    >
      <div
        className="absolute w-full h-full z-[3]"
        onClick={() => setViewDialog(false)}
      ></div>
      <div className="w-full lg:w-4/5 lg:h-full max-h-fit z-[4] px-6 py-6 bg-white rounded-2xl md:h-11/12 flex lg:flex-row md:flex-row flex-col justify-between">
        <div className="flex flex-col lg:w-1/2 px-3 lg:h-full lg:text-start text-center">
          <DialogTitle style={{ padding: "16px 0" }}>
            <strong id="dets">Your booking card</strong>{" "}
            <div className="text-sm text-[#C6C6C6] pt-2" id="dets">
              we got you a card you will use to claim your booked rooms
            </div>
          </DialogTitle>
          <div
            id="form"
            className="w-full flex flex-col lg:justify-between justify-around lg:h-5/6 h-[550px] pt-3 lg:text-lg "
          >
            <div className="flex flex-col lg:justify-between justify-evenly h-2/3 ">
              <div
                id="name"
                className="w-full flex flex-col justify-between lg:gap-2 gap-6"
              >
                <strong className="text-[#515050]  ">Name</strong>
                <div className="flex items-center justify-between ">
                  <span className="w-1/4 text-stone-400  ">Name</span>
                  <span className="w-4/6 text-stone-400  ">{person.Name}</span>
                </div>
                <div className="flex items-center justify-between ">
                  <span className="w-1/4 text-stone-400  ">Contact</span>
                  <span className="w-4/6 text-stone-400  ">
                    +{person.Contact}
                  </span>
                </div>
              </div>

              <div id="bodeets">
                <strong className="text-[#515050]  ">Book details</strong>
                <div className="flex items-start  my-3 justify-around">
                  <span className="w-1/4 text-stone-400 ">Rooms</span>

                  <div className="w-4/6 flex flex-col">
                    <ul>
                      {person.Rooms.map((room) => (
                        <li className="list-disc w-3/4 text-stone-400 lg:text-lg text-sm ">
                          {room.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="w-1/4 text-stone-400 ">N of people</span>
                  <span className="w-4/6 text-stone-400  ">
                    {person.Npeople} people
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="w-1/4 text-stone-400  ">Arrival date</span>

                  <span className="w-4/6 text-stone-400  ">
                    {dateFns.format(person.Arrivaldate, " do MMM yyyy")},{" "}
                    {person.Days} days left
                  </span>
                </div>
              </div>
            </div>

            <div>
              <button className="h-14 w-10/12 bg-[#5182FF] text-white text-sm align-center rounded-md">
                Send card to my email
              </button>
            </div>
          </div>
        </div>

        {/* LEFT PART CONTAINING QR CODE */}
        <div className="text-white flex items-center flex-col justify-between  rounded-xl  lg:w-1/2  pb-5">
          <CloseIcon
            className="lg:text-stone-400 md:text-stone-400 text-transparent cursor-pointer self-end"
            onClick={() => setViewDialog(false)}
          />
          <div
            id="code"
            className="lg:w-3/5 w-80  bg-black text-white "
            style={{ height: "630px" }}
          >
            <div className="flex flex-row justify-around items-center  h-16 rounded-t-xl ">
              <div className="text-md bg-red">
                <strong id="head" className="text-md">
                  Murwiza
                </strong>
              </div>
              <div className="bg-[#191919] h-5 w-5 rounded-xl  self-center "></div>

              <div className="text-[#707070]">
                {dateFns.format(person.Arrivaldate, "yyyy MM do")}
              </div>
            </div>
            <div className="bg-[#191919]  text-center font-bold p-2  border-white  ">
              <strong>Selena Hotel Booking Card</strong>
            </div>
            <div className=" h-5/6 rounded-b-xl flex flex-col justify-evenly">
              <div className="text-[#5D5D5D] text-center lg:p-4 p-3 ">
                All the information needed to prove the ownership and booking
                details are in this code
              </div>
              <div className="">
                <QRCODE
                  className="bg-white p-2"
                  value="murwiza.vercel.app/"
                  style={{ margin: "auto", color: "#" }}
                />
              </div>
              <div className="text-[#5D5D5D] text-center lg:p-4 p-3">
                For informational purposes or misunderstanding contact the
                Murwiza support Team <br />{" "}
                <a
                  href="/"
                  className="text-[#6F6F6F] text-center text-sm font-bold "
                >
                  support@murwiza.rw
                </a>
              </div>

              <div className="text-[#595959] font-bold text-center text-xs mt-1 p-2">
                copyright&copy; murwiza 2022
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function SimpleDialogDemo() {
  const [viewDialog, setViewDialog] = React.useState(false);

  return (
    <div className="flex items-center m-auto justify-between h-screen ">
      <Button
        variant="outlined"
        onClick={() => setViewDialog(true)}
        className=""
      >
        THEE DIALOG BOX
      </Button>

      {viewDialog ? <SimpleDialog setViewDialog={setViewDialog} /> : null}
    </div>
  );
}
